import { render, staticRenderFns } from "./create.vue?vue&type=template&id=903e5b1a&scoped=true&"
import script from "./create.vue?vue&type=script&lang=ts&"
export * from "./create.vue?vue&type=script&lang=ts&"
import style0 from "./create.vue?vue&type=style&index=0&id=903e5b1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903e5b1a",
  null
  
)

export default component.exports